// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"_Y-z","subtitle":"aZ-z","wrapper":"bZ-z","leftArrow":"cZ-z","rightArrow":"dZ-z"};